import { ReactNode } from "react";
import { cn } from "@/core/helpers/cn";

type Props = {
  children: ReactNode;
  className?: string;
  onClick: () => void | Promise<void>;
};

export default function InventoryContextMenuButton({ children, className, onClick }: Props) {
  return (
    <button
      type="button"
      className={cn(
        "text-14 font-medium hover:text-accent-solid transition-all text-left",
        className,
      )}
      onClick={onClick}
    >
      {children}
    </button>
  );
}
